import React from "react";
import { useSelector } from "react-redux";
import StudentPersonalInformation from "./StudentPersonalInformation";
import { TabList, Tab, TabPanels, TabPanel, Tabs } from "@chakra-ui/react";
// import StudentEmployementInformation from "./StudentEmployementInformation";
// import StudentQualificationInformation from "./StudentQualificationInformation";
import StudentMarriageRefereeInfo from "./StudentMarriageRefereeInfo";
import StudentDocumentsUpload from "./StudentDocumentsUpload";

const StudentIndividualDetails = () => {
  const studentIndividualDetails = useSelector(
    (state) => state.modal.formModal?.data
  );

  return (
    <>
      <Tabs variant="unstyled" pt={5}>
        <TabList
          gap={"20px"}
          pb={4}
          sx={{
            overflowY: "scroll",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
          overflowY={"auto"}
        >
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Personal Information
          </Tab>
          {/* <Tab
            _selected={{ color: "#FFFFFF", bg: "#D11A2A" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            PPA Information
          </Tab> */}
          {/* <Tab
            _selected={{ color: "#FFFFFF", bg: "#D11A2A" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Qualifications Information
          </Tab> */}
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Marriage/Referee Info
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Documents Upload
          </Tab>
        </TabList>

        <TabPanels bg={"#FFFFFF"}>
          <TabPanel>
            <StudentPersonalInformation
              studentIndividualDetails={studentIndividualDetails}
            />
          </TabPanel>
          {/* <TabPanel>
            <StudentEmployementInformation
              studentIndividualDetails={studentIndividualDetails}
            />
          </TabPanel> */}
          {/* <TabPanel>
                <StudentQualificationInformation studentIndividualDetails={studentIndividualDetails} />
            </TabPanel> */}
          <TabPanel>
            <StudentMarriageRefereeInfo
              studentIndividualDetails={studentIndividualDetails}
            />
          </TabPanel>
          <TabPanel>
            <StudentDocumentsUpload
              studentIndividualDetails={studentIndividualDetails}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default StudentIndividualDetails;
